import template from './parking-price-monthly.jade';

export default angular
  .module('cian.addForm.commonParkingPriceMonthly', ['cian.addForm.helperPriceCurrencySelect'])
  .directive('cianAfCommonParkingPriceMonthly', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    link(scope, element, attrs, ctrl) {
      let parkingPrice = ctrl.getParking(ctrl.ad).priceMonthly;
      // save and restore value
      scope.$watch(
        () => ctrl.getParking(ctrl.ad).isFree,
        isFree => {
          const isParkingExists = ctrl.isParkingExists(ctrl.ad);

          if (!isParkingExists) {
            return;
          }

          const parking = ctrl.getParking(ctrl.ad);

          if (isFree === true) {
            parkingPrice = parking.priceMonthly;
            parking.priceMonthly = null;
          } else {
            parking.priceMonthly = parkingPrice;
          }
        },
      );
    },
    controller: [
      'deviceService',
      function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.ad.building = this.ad.building || {};
        this.ad.building.parking = this.ad.building.parking || {};

        this.isParkingExists = ad => {
          if (!ad.building || !ad.building.parking) {
            return false;
          }

          return true;
        };

        this.getParking = ad => {
          const building = ad.building || {};
          const parking = building.parking || {};

          return parking;
        };
      },
    ],
    controllerAs: 'parkingPriceMonthly',
    template,
  })).name;
